import { render, staticRenderFns } from "./depo.vue?vue&type=template&id=58936c92"
import script from "./depo.vue?vue&type=script&lang=js"
export * from "./depo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports